import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))



export default {
    namespaced: true,
    state: {
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        findUserBaseLocationOfProduct({commit},form){
            const res = axios.post(`notify-user/find-nearest-user/product/${form.product_id}`,form);
            return res
        },
        sendSmsMessageBaseOnLocationOfProduct({commit},form){
            const res = axios.post(`notify-user/send-message/nearest-user/product/${form.product_id}`,form);
            return res
        },
        checkSmsSendBefore({commit},form){
            const res = axios.post(`notify-user/check/send-sms/product/${form.product_id}`,form);
            return res
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}